import { CrudFilters, HttpError, useCan } from '@refinedev/core';
import { DeleteButton, TextField, useTable } from '@refinedev/antd';
import { DeleteOutlined } from '@ant-design/icons';
import { IProductPossession } from 'interfaces/products';
import { IUser } from 'interfaces/users';
import { Space, Table, Tag } from 'antd';
import { formatDate } from 'services/date';

interface Props {
  userData: IUser;
}

interface IFilter {
  by_user_id: string;
}

const PossessionTable = ({ userData }: Props) => {
  const canListPossessions = useCan({
    resource: 'products/possessions',
    action: 'list'
  });

  const { tableProps } = useTable<IProductPossession, HttpError, IFilter>({
    resource: 'products/possessions',
    queryOptions: {
      enabled: Boolean(canListPossessions.data?.can && userData.id)
    },

    onSearch: () => {
      const filters: CrudFilters = [];

      filters.push({
        field: 'filter[by_user_id]',
        operator: 'eq',
        value: userData.id
      });

      return filters;
    },

    filters: {
      initial: [
        {
          field: 'filter[by_user_id]',
          operator: 'eq',
          value: userData.id
        }
      ]
    }
  });

  return (
    <Table {...tableProps} rowKey="id">
      <Table.Column
        dataIndex="product"
        key="course"
        title="Produto"
        render={({ name }) => <TextField value={name} />}
      />
      <Table.Column
        dataIndex="created_at"
        key="created_at"
        title="Início"
        render={createdAt => <TextField value={formatDate(createdAt, 'l')} />}
      />
      <Table.Column
        dataIndex="expires_at"
        key="expires_at"
        title="Expiração"
        render={expiresAt => (
          <TextField value={expiresAt && formatDate(expiresAt, 'l')} />
        )}
      />
      <Table.Column
        align="center"
        dataIndex={['expires_at', 'disabled_at']}
        key="status"
        title="Status"
        render={(expiresAt, record) => {
          return (record.expires_at && record.expires_at > new Date()) ||
            record.disabled_at ? (
            <Tag color="red">Inativo</Tag>
          ) : (
            <Tag color="green">Ativo</Tag>
          );
        }}
      />
      <Table.Column
        key="action"
        title="Ação"
        render={(text, record) => (
          <Space size="middle">
            <DeleteButton
              icon={<DeleteOutlined />}
              size="small"
              resource="products/possessions"
              recordItemId={record.id}
              disabled={record.disabled_at || record.expires_at > new Date()}
              hideText
              accessControl={{ hideIfUnauthorized: true }}
              confirmTitle="Deseja remover o acesso do usuário a este curso?"
              confirmOkText="Excluir"
              confirmCancelText="Cancelar"
            />
          </Space>
        )}
      />
    </Table>
  );
};

export default PossessionTable;
